import React from 'react';
import ContactBox from 'flow/components/contact-card/ContactBoxTW';
import ContactSettingsItems from 'flow/components/contact-card/ContactSettingsItems';
import useAppContext from 'flow/hooks/useAppContext';
import { Contact } from 'flow/types/Contact';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { TypedMap } from 'flow/types/TypedMap';
import { isThirdPartyContactKey } from 'flow/utils';

interface Props {
    contact?: TypedMap<Contact>;
    extensionKey?: ExtensionKey;
}

const ContactSettingsCard = ({ contact, extensionKey }: Props) => {
    const { i18next } = useAppContext();

    const isContactSaved =
        !!contact?.has('key') && !isThirdPartyContactKey(contact.get('key'));

    if (!isContactSaved) {
        return null;
    }

    return (
        <ContactBox headerTitle={i18next.t('settings')}>
            <div className="flex flex-col pb-4">
                <ContactSettingsItems
                    contact={contact}
                    extensionKey={extensionKey}
                />
            </div>
        </ContactBox>
    );
};

export default ContactSettingsCard;
